import { Activity } from "$types";

export type ActivityOption = {
  _id: string;
  helpText?: string;
  label: string;
  name: string;
  value: string;
};

export const ACTIVITIES_LABELS = {
  chartering: "Affrètement",
  courier: "Coursier",
  express: "Express",
  logisticsManagement: "Gestion Logistique",
  messaging: "Messagerie",
  xDock: "X-Dock",
};

export const HELP_TEXTS = {
  logisticsManagement:
    "Gestion des entrées, sorties, stock et préparations de commandes",
  xDock:
    "Réception des préparations et mise à disposition auprès des intervenants. Gestion de la collecte de matériel retour",
};

export const getActivitiesOptions = (
  activities: Activity[]
): ActivityOption[] =>
  (activities || [])
    .map((activity) => ({
      _id: activity._id,
      value: activity._id,
      helpText: HELP_TEXTS[activity.name],
      label: Object.keys(ACTIVITIES_LABELS).includes(activity.name)
        ? ACTIVITIES_LABELS[activity.name]
        : activity.name,
      name: activity.name,
    }))
    .sort((a1, a2) => a1.label.localeCompare(a2.label));
